export default function _(s) {
  try {
    return window.gettext(s)
  } catch (e) {
    return s;
  }
}